<script>
  import ChatMessage from './chat-message'

  export default {
    extends: ChatMessage,

    computed: {
      /**
       * @return {String}
       */
      content() {
        return String(_.get(this.message, 'content') || '').trim();
      },

      /**
       * @return {String}
       */
      status() {
        return '';
      },
    },
  }
</script>
